import { useCallback, useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { useSelector } from "react-redux"
import { eお知らせ分類区分 } from "../../../constant/enum/master"
import { RootState } from "../../../globalStore/rootreducer"
import { TLoginUserInfo } from "../../../service/auth/TAuth"
import OsiraseService from "../../../service/master/osirase/osiraseService"
import { TOsiraseGetListRes } from "../../../service/master/osirase/TOsirase"
import TopCategoryOuter from "../TopCategoryOuter"
import { OsiraseGrid } from "./OsiraseGrid"

const Osirase = () => {
  const [searchStart, setSearchStart] = useState(false)
  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)

  const [お知らせList, setお知らせList] = useState<TOsiraseGetListRes[]>()

  const [システム情報List, setシステム情報List] =
    useState<TOsiraseGetListRes[]>()

  const searchFunction = useCallback(
    async (userInfo: TLoginUserInfo) => {
      const お知らせRes = await new OsiraseService().getList({
        掲載日: 営業日,
        表示部所未入力表示フラグ: 1,
        部所コード: userInfo.部所コード,
      })

      setお知らせList([
        ...お知らせRes?.data?.filter(
          (d) => d.お知らせ分類区分コード !== eお知らせ分類区分.システム関連
        ),
      ])

      setシステム情報List([
        ...お知らせRes?.data?.filter(
          (d) => d.お知らせ分類区分コード === eお知らせ分類区分.システム関連
        ),
      ])

      setSearchStart(false)
    },
    [営業日]
  )

  useEffect(() => {
    setSearchStart(true)
  }, [])

  return (
    <Card>
      <Card.Body>
        <TopCategoryOuter
          searchFunction={searchFunction}
          searchStartFlag={searchStart}>
          <h4 className="topLabel">お知らせ</h4>
          {お知らせList != null && お知らせList.length > 0 ? (
            <OsiraseGrid
              className="max-h-8rem"
              osiraseList={お知らせList}></OsiraseGrid>
          ) : (
            <span>お知らせはありません</span>
          )}
          <br />
          <h4 className="topLabel">システムメンテナンスのお知らせ</h4>
          {システム情報List != null && システム情報List.length > 0 ? (
            <OsiraseGrid
              className="max-h-6rem"
              osiraseList={システム情報List}></OsiraseGrid>
          ) : (
            <span>システム情報はありません</span>
          )}
        </TopCategoryOuter>
      </Card.Body>
    </Card>
  )
}

export default Osirase
